import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class CoverageService {

    getEventRoute = '/api/coverage/';

    constructor(private dataService: DataService) {
    };

    checkCoverage(result: any) {
        return this.dataService.post('/api/coverage/checkCoverage', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getLocationReference(data, refresh: boolean) {
        // return this.dataService.getRecord('/api/application/getPaymentHistoryWithReference/' + reference);
        return this.dataService.getRecord('/api/coverage/getlocationreference/' + data.longitude + '/' + data.latitude + '/' + data.areaId);
    }

    getOpenserveProductQuality(data, refresh: boolean) {
        // return this.dataService.getRecord('/api/application/getPaymentHistoryWithReference/' + reference);
        return this.dataService.getRecord('/api/coverage/getOpenserveProductQuality/' + data.longitude + '/' + data.latitude);
    }

    getLocationAddress(fulladdress, refresh: boolean) {
        return this.dataService.getRecord('/api/coverage/getlocationaddress/' + fulladdress);
    }

    getAddressByUnitNoAndName(address: any) {
        return this.dataService.post('/api/coverage/getaddressbyunitnoandname', address).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    checkCanCreateOrder(locationreference: any) {
        return this.dataService.post('/api/coverage/checkCanCreateOrder', locationreference).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }


    getZoomLocationPremises(data: any) {
        return this.dataService.post('/api/zoom/GetZoomLocationPremises/', data);
    }


    checkHomeCoverage(result: any) {
        return this.dataService.getHomeConnectRecordWithParams('/api/coverage/checkCoverage', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    CheckPremiseIsAvailable(data: any) {
        return this.dataService.post('/api/zoom/CheckPremiseIsAvailable/', data);
    }

}
